
const digest = '9c07e2c8153dfe718985af195b557c3629b587d622c519b2b98388398963fd2e';
const classes = {"wrapper":"_wrapper_kxc23_1","available":"_available_kxc23_7","subscription":"_subscription_kxc23_23","box1":"_box1_kxc23_28","title":"_title_kxc23_34","item":"_item_kxc23_38","itemTitle":"_itemTitle_kxc23_46","itemSubtitle":"_itemSubtitle_kxc23_49","box2":"_box2_kxc23_53","price":"_price_kxc23_66","button":"_button_kxc23_75","dph":"_dph_kxc23_83","agreement":"_agreement_kxc23_87"};
const css = `._wrapper_kxc23_1 {
  font-family: Rubik, "sans-serif";
  display: flex;
  flex-direction: column;
  gap: 20px;
}
._wrapper_kxc23_1 ._available_kxc23_7 {
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 6px;
  font-size: 14px;
  background: #ecfdf5;
  padding: 14px 20px;
  border-radius: 25px;
  border: 1px solid rgba(209, 250, 229, 0.5019607843);
  color: #047857;
}
._wrapper_kxc23_1 ._available_kxc23_7 img {
  height: 25px;
}

._subscription_kxc23_23 {
  display: flex;
  flex-direction: row;
  gap: 40px;
}
._subscription_kxc23_23 ._box1_kxc23_28 {
  display: flex;
  flex-direction: column;
  gap: 20px;
  flex: 1;
}
._subscription_kxc23_23 ._box1_kxc23_28 ._title_kxc23_34 {
  font-weight: 600;
  font-size: 18px;
}
._subscription_kxc23_23 ._box1_kxc23_28 ._item_kxc23_38 {
  display: flex;
  flex-direction: row;
  gap: 15px;
}
._subscription_kxc23_23 ._box1_kxc23_28 ._item_kxc23_38 img {
  height: 25px;
}
._subscription_kxc23_23 ._box1_kxc23_28 ._item_kxc23_38 ._itemTitle_kxc23_46 {
  font-weight: 500;
}
._subscription_kxc23_23 ._box1_kxc23_28 ._item_kxc23_38 ._itemSubtitle_kxc23_49 {
  font-size: 14px;
  color: #424754;
}
._subscription_kxc23_23 ._box2_kxc23_53 {
  display: flex;
  flex-direction: column;
  background: #f3f4f5;
  padding: 40px;
  border-radius: 25px;
  text-align: center;
  gap: 20px;
}
._subscription_kxc23_23 ._box2_kxc23_53 ._title_kxc23_34 {
  font-weight: 600;
  font-size: 18px;
}
._subscription_kxc23_23 ._box2_kxc23_53 ._price_kxc23_66 {
  color: #1d65d8;
  font-weight: 700;
  font-size: 32px;
}
._subscription_kxc23_23 ._box2_kxc23_53 ._price_kxc23_66 span {
  color: #424754;
  font-size: 16px;
}
._subscription_kxc23_23 ._box2_kxc23_53 ._button_kxc23_75 {
  font-size: 18px;
  font-weight: 600;
  background: linear-gradient(135deg, #1e6ce3 0%, #0054bc 100%);
  --tw-shadow: 0 10px 15px -3px rgb(0 0 0 / 0.1), 0 4px 6px -4px rgb(0 0 0 / 0.1);
  --tw-shadow-colored: 0 10px 15px -3px var(--tw-shadow-color), 0 4px 6px -4px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 rgba(0, 0, 0, 0)), var(--tw-ring-shadow, 0 0 rgba(0, 0, 0, 0)), var(--tw-shadow);
}
._subscription_kxc23_23 ._box2_kxc23_53 ._dph_kxc23_83 {
  color: #424754;
  font-size: 14px;
}
._subscription_kxc23_23 ._box2_kxc23_53 ._agreement_kxc23_87 {
  font-size: 12px;
  color: #424754;
}`;

(function() {
  if (typeof document !== "undefined" && !document.getElementById(digest)) {
    var ele = document.createElement('style');
    ele.id = digest;
    ele.textContent = css;
    document.head.appendChild(ele);
  }
})();

export default classes;
export { css, digest, classes };
  